/**
 * Design Tokens for Repli Sandbox Preferred Theme
 * 
 * Extends the base preferred theme tokens with Repli Sandbox Preferred branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-preferred/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Repli Sandbox Preferred brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Repli Sandbox Preferred brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Repli Sandbox Preferred typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
